import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Banknote, Shield, Zap, BookOpen } from 'lucide-react';

var CATEGORY_META = {
  financial: { label: 'Financial Actions (Highest Impact)', icon: Banknote, color: 'text-emerald-600', bg: 'bg-emerald-50' },
  trust: { label: 'Trust Building', icon: Shield, color: 'text-blue-600', bg: 'bg-blue-50' },
  core: { label: 'Core Actions', icon: Zap, color: 'text-amber-600', bg: 'bg-amber-50' },
  engagement: { label: 'Engagement (Capped)', icon: BookOpen, color: 'text-violet-600', bg: 'bg-violet-50' },
};

var WEIGHT_BADGE = {
  high: 'bg-emerald-100 text-emerald-700',
  medium: 'bg-amber-100 text-amber-700',
  low: 'bg-slate-100 text-slate-500',
};

function HowToEarn(props) {
  var categories = props.categories;
  if (!categories) return null;

  // Display order: financial first, then trust, core, engagement
  var orderedKeys = ['financial', 'trust', 'core', 'engagement'].filter(function(k) { return categories[k]; });

  return (
    <div className="space-y-3" data-testid="how-to-earn">
      <Card className="glass-card border-l-4 border-l-[#0B1F3A] mb-2">
        <CardContent className="p-3">
          <p className="text-xs text-slate-600">
            <strong>Financial actions</strong> have the highest impact on your credibility score.
            Engagement tasks are <strong>capped daily</strong> to prevent abuse.
          </p>
        </CardContent>
      </Card>

      {orderedKeys.map(function(catKey) {
        var meta = CATEGORY_META[catKey] || CATEGORY_META.core;
        var Icon = meta.icon;
        var tasks = categories[catKey];

        return (
          <Card key={catKey} className="glass-card">
            <CardHeader className="pb-2">
              <CardTitle className="text-sm flex items-center gap-2">
                <div className={'p-1.5 rounded-lg ' + meta.bg}>
                  <Icon size={14} className={meta.color} />
                </div>
                <span className="text-slate-800">{meta.label}</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-0">
              <div className="space-y-1.5">
                {tasks.map(function(task) {
                  var wClass = WEIGHT_BADGE[task.weight] || WEIGHT_BADGE.medium;
                  return (
                    <div key={task.id} className="flex items-center justify-between py-1.5 border-b border-slate-50 last:border-0">
                      <div className="flex items-center gap-2">
                        <span className="text-xs text-slate-600">{task.label}</span>
                        {task.daily_limit > 0 && (
                          <span className="text-[9px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-400">max {task.daily_limit}/day</span>
                        )}
                      </div>
                      <div className="flex items-center gap-1.5">
                        <span className={'text-[9px] px-1.5 py-0.5 rounded-full font-medium ' + wClass}>{task.weight}</span>
                        <span className="text-xs font-bold text-emerald-600">+{task.points}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}

export default HowToEarn;
